<p class="mb-6 text-generic">
    {{ 'BUSINESS_ADDRESS.ENTER_DETAILS' | translate }}
</p>

<form [formGroup]="businessAddressForm" class="space-y-8" (ngSubmit)="handleFormSubmission()">
    <!-- Section Title -->
    <p class="text-base font-medium mb-6 text-(--text-muted)">
        {{ 'BUSINESS_ADDRESS.SECTION_TITLE' | translate }}
    </p>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
        <!-- Country -->
        <div>
            <app-custom-dropdown label="{{ 'BUSINESS_ADDRESS.COUNTRY' | translate }}" placeholder="BUSINESS_ADDRESS.PLEASE_SELECT"
                [options]="countriesOptions" [isSearchable]="true"
                searchPlaceholder="{{ 'BUSINESS_ADDRESS.SEARCH_COUNTRY' | translate }}"
                (optionSelected)="onDropdownSelect('country', $event)" customClass="!mb-0">
            </app-custom-dropdown>
        </div>

        <!-- City -->
        <div>
            <app-custom-dropdown label="{{ 'BUSINESS_ADDRESS.CITY' | translate }}" placeholder="BUSINESS_ADDRESS.PLEASE_SELECT"
                [options]="countriesOptions" [isSearchable]="true" searchPlaceholder="{{ 'BUSINESS_ADDRESS.SEARCH_CITY' | translate }}"
                (optionSelected)="onDropdownSelect('city', $event)" customClass="!mb-0">
            </app-custom-dropdown>
        </div>

        <!-- District -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.DISTRICT' | translate }}" placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                customClass="!mb-0" [control]="getControl('district')">
            </app-input-field>
        </div>

        <!-- Area -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.AREA' | translate }}" placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                customClass="!mb-0" [control]="getControl('area')">
            </app-input-field>
        </div>

        <!-- Street Name -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.STREET_NAME' | translate }}" placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                customClass="!mb-0" [control]="getControl('streetName')">
            </app-input-field>
        </div>

        <!-- Empty space for layout -->
        <div class="sm:block hidden"></div>

        <!-- Building Number -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.BUILDING_NUMBER' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0" [isRequired]="false"
                [control]="getControl('buildingNumber')">
            </app-input-field>
        </div>

        <!-- Office Number -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.OFFICE_NUMBER' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0" [isRequired]="false"
                [control]="getControl('officeNumber')">
            </app-input-field>
        </div>

        <!-- Nearest Landmark -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.NEAREST_LANDMARK' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"  [isRequired]="false" customClass="!mb-0"
                [control]="getControl('nearestLandmark')">
            </app-input-field>
        </div>

        <!-- PO Box -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.PO_BOX_NUMBER' | translate }}"
                placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" customClass="!mb-0"
                [control]="getControl('poBoxNumber')">
            </app-input-field>
        </div>

        <!-- Business Contact -->
        <p class="text-base font-medium mb-0 sm:col-span-2 text-(--text-muted)">
            {{ 'BUSINESS_ADDRESS.BUSINESS_CONTACT' | translate }}
        </p>

        <!-- Corporate Phone -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.CORPORATE_PHONE_NUMBER' | translate }}" type="number" [isMobile]="true"
                placeholder="7900000000" [control]="getControl('corporatePhone')">
            </app-input-field>
        </div>

        <!-- Email -->
        <app-input-field label="{{ 'BUSINESS_ADDRESS.EMAIL' | translate }}" type="email"
            placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}" [control]="getControl('email')">
        </app-input-field>

        <!-- Website -->
        <div>
            <app-input-field label="{{ 'BUSINESS_ADDRESS.WEBSITE' | translate }}" placeholder="{{ 'LOGIN.PLACEHOLDER' | translate }}"
                customClass="!mb-0" [control]="getControl('website')">
            </app-input-field>
        </div>
    </div>

    <!-- Submit Button -->
    <app-button text="{{ 'BUSINESS_ADDRESS.CONTINUE' | translate }}" type="submit" variant="primary" size="lg"
        extraClass="mt-3 mb-12 w-full" [disabled]="businessAddressForm.invalid">
    </app-button>
</form>